module.exports = __webpack_public_path__ + "img/short.be5030ca.webp";